export default __webpack_public_path__ + "static/media/testSeriesIcon.47caf805.svg";